import { XHR } from "./polling-xhr.node.js";
import { WS } from "./websocket.node.js";
import { WT } from "./webtransport.js";
export const transports = {
    websocket: WS,
    webtransport: WT,
    polling: XHR,
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/engine.io-client/build/esm/transports/index.js
// module id = 719
// module chunks = 0